import type { KeyInfo } from './index'

export type KeyResults = {
  id: String,
  keys: KeyInfo[],
};